import { chip } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'chip',
  label: 'Chip',
  category: 'Data Display',
  image: chip
};
